export type TaxConfigurationItem = {
    taxRate: number | null;
    taxRatePre?: number | null;
    taxRefundRate: number | null;
    taxRateValidFrom?: Date | null;
};

export type TaxOptions = {
    isVatRegistered: boolean;
    salesTax: TaxConfigurationItem;
    adSpendTax: TaxConfigurationItem;
    costTax: TaxConfigurationItem;
    platformFeeTax: TaxConfigurationItem;
    affiliateCommissionTax: TaxConfigurationItem;
    fbmShippingCostTax: TaxConfigurationItem;
    fbtShippingCostTax: TaxConfigurationItem;
    sellerShippingCostTax: TaxConfigurationItem;
    fbtFulfilmentAndPackagingFeesTax: TaxConfigurationItem;
    fbtShippingCostTaxBack: TaxConfigurationItem;
}

export const defaultTaxOptions: TaxOptions = {
    isVatRegistered: true,
    salesTax: {
        taxRate: 20,
        taxRatePre: 0,
        taxRefundRate: 20,
        taxRateValidFrom: null,
    },
    adSpendTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    costTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    platformFeeTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    affiliateCommissionTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    fbmShippingCostTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    fbtShippingCostTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    sellerShippingCostTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    fbtFulfilmentAndPackagingFeesTax: {
        taxRate: 20,
        taxRefundRate: 20,
    },
    fbtShippingCostTaxBack: {
        taxRate: 20,
        taxRefundRate: 20,
    }
}